// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React from 'react';
import cn from 'classnames';
import {Lottie} from '../../lib/lottie';
import {img_url} from '../img_url';
import styles from './loader.module.less';

interface i_loader_props {
    is_loading: boolean;
    cls?: string;
}
export const Loader = (props: i_loader_props)=>{
    const {is_loading, cls} = props;
    return <div className={styles.loader_container}>
      <div className={cn(styles.loader, cls, is_loading && styles.shown)}>
        <Lottie autoplay loop width="375" height="375"
        src={img_url('animation/hola2023_loader.json')}/>
      </div>
    </div>;
};
